/**
 * Postgres interval strings, made readable.
 *
 * The backend sends `minimum_rental`, `billing_increment`, `late_grace` and the
 * buffers as raw interval text (`1 day`, `04:00:00`, `1 mon`). It is passed
 * through verbatim rather than converted to a number of hours, because the
 * conversion would have to assume a calendar the API did not state.
 *
 * This only makes the text readable. Where a string cannot be parsed it is
 * returned UNCHANGED — a value shown exactly as the backend sent it is honest;
 * a guess is not.
 */
const UNIT_WORDS = {
    mon: ['month', 'months'],
    mons: ['month', 'months'],
    day: ['day', 'days'],
    days: ['day', 'days'],
    year: ['year', 'years'],
    years: ['year', 'years'],
    hour: ['hour', 'hours'],
    hours: ['hour', 'hours'],
    min: ['minute', 'minutes'],
    mins: ['minute', 'minutes'],
};
function plural(count, word) {
    return `${count} ${count === 1 ? word[0] : word[1]}`;
}
export function formatInterval(value) {
    if (value === null || value === undefined)
        return null;
    const text = value.trim();
    if (text === '')
        return null;
    const parts = [];
    let matchedSomething = false;
    for (const match of text.matchAll(/(-?\d+)\s+([a-z]+)/gi)) {
        const word = UNIT_WORDS[match[2].toLowerCase()];
        if (word) {
            parts.push(plural(Number(match[1]), word));
            matchedSomething = true;
        }
    }
    // `HH:MM:SS`, the form Postgres uses for sub-day intervals.
    const clock = /(\d+):(\d{2}):(\d{2})/.exec(text);
    if (clock) {
        const hours = Number(clock[1]);
        const minutes = Number(clock[2]);
        if (hours > 0)
            parts.push(plural(hours, ['hour', 'hours']));
        if (minutes > 0)
            parts.push(plural(minutes, ['minute', 'minutes']));
        if (hours === 0 && minutes === 0 && parts.length === 0)
            return text;
        matchedSomething = true;
    }
    if (!matchedSomething || parts.length === 0)
        return text;
    return parts.join(' ');
}
/** Basis points as the backend states them: 12500 → `125%`. */
export function formatBasisPoints(bp) {
    if (bp === null || bp === undefined)
        return null;
    const percent = bp / 100;
    return `${Number.isInteger(percent) ? percent : percent.toFixed(2)}%`;
}
/** `overnight_return` → `Overnight return`. Never invents copy. */
export function humaniseCode(code) {
    if (code === null || code === undefined || code === '')
        return null;
    const words = code.replace(/_/g, ' ');
    return words.charAt(0).toUpperCase() + words.slice(1);
}
//# sourceMappingURL=interval.js.map